export default {"src":"/_next/static/media/pharma-manufacturing-firm.9641fb5c.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};